import LastOrderDate from './LastOrderDate/LastOrderDate';
import ContactNo from './ContactNo/ContactNo';

const TableCell = {
  LastOrderDate: LastOrderDate,
  ContactNo: ContactNo,
};

export default TableCell;
